import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate, useOutletContext } from 'react-router-dom'
import { Container, TextField } from '@mui/material'

import { Car } from '../api/index'
import ButtonBox from '../components/ButtonBox'
import Section from '../components/Section'
import SectionHeader from '../components/SectionHeader'
import useAlert from '../hooks/useAlert'
import useAuth from '../hooks/useAuth'
import useAxiosPrivate from '../hooks/useAxiosPrivate'

function ControlNewCar() {
  const { setCar } = useOutletContext()
  const { auth } = useAuth()
  const axiosPrivate = useAxiosPrivate()
  const { setAlert } = useAlert()
  const [vin, setVin] = useState('')
  const [isBtnLoading, setIsBtnLoading] = useState(false)
  const navigate = useNavigate()
  const { t } = useTranslation(['common', 'create'])

  useEffect(() => {
    setCar({})
    sessionStorage.setItem('digitalCertificateId', '')
  }, [setCar])

  const onChange = (e) => {
    setVin(e.target.value)
  }

  const getCarData = () => {
    setIsBtnLoading(true)

    if (vin) {
      Car.getCar(axiosPrivate, vin, auth.dealerId)
        .then(({ data }) => {
          setCar(data)
          navigate('/controls/new/type')
        })
        .catch(() => {
          setAlert(t('create:start.form.error.notExist'), 'info')
          navigate(`/controls/new/type?vin=${vin}`)
        })
        .finally(() => {
          setIsBtnLoading(false)
        })
    } else {
      navigate('/controls/new/type')
    }
  }

  return (
    <Container maxWidth="xl">
      <Container maxWidth="sm">
        <Section>
          <SectionHeader
            title={t('create:start.title')}
            subtitle={t('create:start.subtitle')}
          />
          <TextField
            name="vin"
            label={t('create:start.form.input.vin.label')}
            placeholder={t('create:start.form.input.vin.placeholder')}
            variant="outlined"
            fullWidth
            onChange={onChange}
            value={vin}
            InputLabelProps={{ shrink: true }}
          ></TextField>
        </Section>
        <ButtonBox
          mt={2}
          buttons={[
            {
              label: t('button.back'),
              props: {
                variant: 'outlined',
                color: 'primary',
                component: Link,
                to: '/controls',
                reloadDocument: true,
              },
            },
            {
              label: t('button.next'),
              props: {
                variant: 'contained',
                color: 'primary',
                loading: isBtnLoading,
                onClick: getCarData,
              },
            },
          ]}
        />
      </Container>
    </Container>
  )
}
export default ControlNewCar
